import { Dropdown } from '@shared/components/dropdown/model/dropdown';

export const locationSuggestion: Dropdown[] = [
  {
    label: 'Paris',
    key: 'paris',
    zipcode: '75000',
    lat: 48.856614,
    lng: 2.3522219,
  },
  {
    label: 'Lyon',
    key: 'lyon',
    zipcode: '69000',
    lat: 45.764043,
    lng: 4.835659,
  },
  {
    label: 'Marseille',
    key: 'marseille',
    zipcode: '13000',
    lat: 43.296482,
    lng: 5.36978,
  },
  {
    label: 'Annecy',
    key: 'annecy',
    zipcode: '74000',
    lat: 45.899247,
    lng: 6.129384,
  },
  {
    label: 'Arcachon',
    key: 'arcachon',
    zipcode: '33120',
    lat: 44.654243,
    lng: -1.163164,
  },
  {
    label: 'Aix-en-Provence',
    key: 'aix-en-provence',
    zipcode: '13100',
    lat: 43.529742,
    lng: 5.447427,
  },
];
